<template>
  <div class="collections-index">
    <section>
      <router-link v-for="item in collectionsSorted" :key="item.id" :to="'/collections/' + item.uid" v-if="!isHidden(item)">
        <article>
          <header class="sticky-header uppercase">
            <h2 class="h4">
              <template v-if="!isBespoke(item)">
                Collection
              </template>
              <br>
              <template v-if="item.getText('collection.number')">
                Nr. <span v-html="item.getText('collection.number')"></span>
                <br>
              </template>
              <template v-if="isBespoke(item)">
                Dovedale Design<br/>Studio’s<br/>
              </template>
              <span v-html="item.getText('collection.title')"></span>
            </h2>
              <nav class="h8 is-hidden-mobile">
                <template v-if="isBespoke(item)">
                  <a>View&nbsp;Gallery</a>
                  <router-link :to="'/collections/' + item.uid + '/items'">Enquire</router-link>
                  <!-- <a href="mailto:info@dovedaledesignstudio.com">Enquire</a> -->
                </template>
                <template v-else>  
                  <a>View&nbsp;Collection</a>
                  <router-link :to="'/collections/' + item.uid + '/items'">Purchase&nbsp;Collection</router-link>
                </template>
              </nav>
          </header>
          <section>
            <div v-for="photo in item.getGroup('collection.index-images').toArray()" :style="{backgroundImage: 'url(' + respImgUrl(photo) + ')'}"></div>
          </section>
        </article>
      </router-link>
    </section>
    <appfooter :site="site"></appfooter>
  </div>
</template>

<script>
import Vue from 'vue'
import stickyHeaders from 'assets/js/sticky-headers'
import SubscribeForm from 'src/components/SubscribeForm'
import Appfooter from 'src/components/Footer'
export default {
  name: 'collections',
  props: ['window', 'site', 'collections'],
  components: {
    SubscribeForm,
    Appfooter
  },
  data () {
    return {
      stickyHeaders: []
    }
  },
  computed: {
    mailchimpNewsletterID () {
      return this.site ? this.site.getText('site.mailchimp-newsletter-id') : ''
    },
    collectionsSorted () {
      return this.collections.sort((a, b) => {
        const aNum = a.getText('collection.number') ? a.getText('collection.number') : 999
        const bNum = b.getText('collection.number') ? b.getText('collection.number') : 999
        if (aNum && bNum) {
          return aNum - bNum
        }
        return 0
      })
    }
  },
  methods: {
    isBespoke (item) {
      if (item.slug === 'bespoke-service') {
        return true
      }
    },
    isHidden (item) {
      const data = item.data['collection.visible']
      return data && data.value === 'false'
    },
    respImgUrl (photo) {
      const w = window.innerWidth
      if (w > 1600) {
        return photo.getImage('image').url
      }
      const size = w > 1024 ? 'laptop' : 'tablet'
      return photo.getImageView('image', size).url
    },
    onScroll () {
      if (!window.Modernizr.cssstickypositifon && window.innerWidth > this.window.bkpt.mobile) {
        stickyHeaders(this.stickyHeaders, window.pageYOffset, this.window.height)
      }
    },
    detectSafari () {
      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        document.getElementsByTagName('html')[0].setAttribute('data-browser', 'safari')
      }
    }
  },
  mounted () {
    this.stickyHeaders = this.$el.querySelectorAll('.sticky-header')
    this.detectSafari()
  },
  created () {
    window.addEventListener('scroll', this.onScroll)
    Vue.updateMeta.setTitle('Collections')
    Vue.updateMeta.setDescription()
  },
  destroyed () {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style lang="scss" scoped>
@import '../style/variables';

.collections-index{
  background:$white;
  min-height:100vh;
  width:100%;

  article{
    position: relative;
    min-height:100vh;
    @include clearFloat();
    // left panel
    > header{
      position:absolute;
      position:sticky;
      top:0;
      left:0;
      width:50%;
      height:100vh;
      padding:0 $gutter*2;
      @include vcenter_content($child:'> h2');
      border-bottom-style:solid;
      border-color:$gray;
      // collection title
      > h2{
        width: 100%;
        line-height:12.9vh;
      }
      // view collection link
      > nav{
        position: absolute;
        bottom:9vh; left:0;
        width:100%;
        padding:0 $gutter;
        > a{
          display:inline-block;
          padding:$gutter/2 $gutter;
        }
      }
    }
    &:last-child{
      > header{
        border-bottom-style: none;
      }
    }
    // right panel
    > section{
      width:50%;
      margin-left:50%;
      min-height:100vh;
      background:$black;
      > div{
        height:100vh;
        background-size:cover;
        background-position:center center;
      }
    }
  }

  @include mobile_landscape {
    .h4{
      font-size:(2.1825*.85em);
    }
  }

  @include on_mobile() {
    padding-top:$mobileNavHeight;
    article{
      position: relative;
      height:100vh; // calc(100vh - #{$mobileNavHeight});
      // min-height:600px;
      // min-height:480px;
      overflow:hidden;
      color:$white;
      > header, > section {
        position:absolute;
        width:100%;
        height:100%;
        margin:0;
        top:0; left:0;
      }
      > header{
        z-index:10;
        background:transparent;
      }
      > section{
        z-index:1;
      }
      .h4{
        font-size:(28/16)*1em;
      }
    }
    > footer{
      margin:6.25em 0;
      padding:0 $gutter;
      > div{
        max-width:29.8125em;
        margin:0 auto;  
      }
    }
  }

  // @include above_mobile_nav() {
    // css sticky supported
    .csspositionsticky &{
      .sticky-header{
        float:left;
      }
      .sticky-header + section {
        margin-left:0;
        float:right;
      }
    }

    // safari bug during right transition (negative translateX)
    .csspositionsticky[data-browser="safari"] &.slide-right-enter-active{
      .sticky-header{
        position:relative !important;
      }
    }
  // }
}
</style>



// WEBPACK FOOTER //
// Collections.vue?63357df4